import {createSelector, createSlice} from '@reduxjs/toolkit';

import {TAppState} from 'store/config/types';

import {EXTERNAL_LOADING_SLICE} from './external-loading-constants';
import {clearStageThunk, loadOpenInterface} from './external-loading-thunks';
import {TExternalLoadingSliceState} from './external-loading-types';
import {generateUnifiedFieldsColumns} from './open-interface/open-interface-utils';

export const externalLoadingSlice = createSlice({
    initialState: {
        openInterfaceData: [],
        openInterfaceColumns: [],
    } as TExternalLoadingSliceState,
    name: EXTERNAL_LOADING_SLICE,
    reducers: {
        resetOpenInterfaceData(state) {
            state.openInterfaceData = [];
            state.openInterfaceColumns = [];
        },
        clearStage(state) {
            state.openInterfaceData = [];
            state.openInterfaceColumns = [];
        },
    },
    extraReducers: builder => {
        builder.addCase(loadOpenInterface.fulfilled, (state, {payload}) => {
            state.openInterfaceData = payload;
            state.openInterfaceColumns = generateUnifiedFieldsColumns(payload);
        });
        builder.addCase(clearStageThunk.fulfilled, state => {
            state.openInterfaceData = [];
        });
    },
});

const selectExternalLoadingSliceState = (state: TAppState) => state[EXTERNAL_LOADING_SLICE];

const selectOpenInterfaceData = createSelector(
    selectExternalLoadingSliceState,
    ({openInterfaceData}) => openInterfaceData,
);

const selectOpenInterfaceColumns = createSelector(
    selectExternalLoadingSliceState,
    ({openInterfaceColumns}) => openInterfaceColumns,
);

export const externalLoadingSelectors = {
    selectExternalLoadingSliceState,
    selectOpenInterfaceData,
    selectOpenInterfaceColumns,
};

export const {
    reducer: externalLoadingSliceReducer,
    actions: externalLoadingSliceActions,
} = externalLoadingSlice;
